import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[appAuthContent]',
  standalone: true
})
export class AuthContentDirective {
  public templateRef = inject(TemplateRef<unknown>);
}
